import { faClose, faListCheck } from "@fortawesome/free-solid-svg-icons"
import { useTranslation } from "react-i18next"
import Animate, { AnimationTypes } from "../../../components/Animate/Animate"
import { ButtonIcon } from "../../../components/Button/Button"
import { PopupHelpButton } from "../../../components/Help/PopupHelpButton"
import ModalPortal from "../../../components/Modal/ModalPortal"
import { TimeClockCardGrid } from "../../../components/TimeClock/TimeClockCardGrid"
import { TitlePageResponsiveIconSmall } from "../../../components/Titles/Titles"
import { SIZE } from "../../../configuration/Sizes"
import THEME from "../../../configuration/Theme"
import type { ListItem } from "../../../components/List/List"
import defaultStyle from "../../../styles/defaultPageStyle.module.css"
import GetSpace from "../../../utils/space"

interface TimeClockReportsEntriesPopupProps {
  cards: ListItem[]
  onClose: () => void
}

export const TimeClockReportsEntriesPopup: React.FC<TimeClockReportsEntriesPopupProps> = ({ cards, onClose }) => {
  const { t } = useTranslation(["timeClock", "helpPopup"])

  return (
    <ModalPortal>
      <div className={defaultStyle.overlay}>
        <Animate type={AnimationTypes.slideUpIn} duration="0.3s">
          <div className={defaultStyle.alert1}>
            <TitlePageResponsiveIconSmall
              title={t("management.period_entries")}
              icon={faListCheck}
              iconColor={THEME.colors.iconBGColor}
              children={
                <div className={`${defaultStyle.ButtonsActions} flex items-center gap-1`}>
                  <PopupHelpButton
                    variant="global"
                    helpKey="pages.time-clock-reports-entries"
                    title={t("helpPopup:global.timeClockReportsEntries.title")}
                    description={t("helpPopup:global.timeClockReportsEntries.description")}
                    bullets={t("helpPopup:global.timeClockReportsEntries.bullets", { returnObjects: true }) as string[]}
                  />

                  <ButtonIcon
                    sizeNumber={SIZE.buttonCloseIconSize}
                    bgColor={THEME.colors.buttonBGCloseColor}
                    iconColor={THEME.colors.buttonFGCloseColor}
                    icon={faClose}
                    onClick={onClose}
                    size="small"
                    descriptionKey="interactionDescriptions:pages.myRestaurant.timeClock.timeClockReportsEntriesPopup.button.onClose"
                  />
                </div>
              }
            />

            <GetSpace top={10} />

            <div className="max-h-[72vh] overflow-y-auto p-2">
              <TimeClockCardGrid
                items={cards}
                emptyLabel={t("management.no_entries")}
                descriptionKey="interactionDescriptions:pages.myRestaurant.timeClock.timeClockReportsEntriesPopup.card.entry"
              />
            </div>
          </div>
        </Animate>
      </div>
    </ModalPortal>
  )
}
